export const techData = [
  {
    slug: "inmobi-real-state",
    analysis: {
      sectionTitle: "portfolio.p1.analysis.sectionTitle",
      subject1: "portfolio.p1.analysis.subject1",
      name1: "portfolio.p1.analysis.name1",
      description1: "portfolio.p1.analysis.description1",
      role1: "portfolio.p1.analysis.role1",

      subject2: "portfolio.p1.analysis.subject2",
      name2: "portfolio.p1.analysis.name2",
      description2: "portfolio.p1.analysis.description2",
      role2: "portfolio.p1.analysis.role2",

      subject3: "portfolio.p1.analysis.subject3",
      name3: "portfolio.p1.analysis.name3",
      description3: "portfolio.p1.analysis.description3",
      role3: "portfolio.p1.analysis.role3",
    }
  },
  {
    slug: "procesos-migratorios-apm",
    analysis: {
      sectionTitle: "portfolio.p2.analysis.sectionTitle",
      subject1: "portfolio.p2.analysis.subject1",
      name1: "portfolio.p2.analysis.name1",
      description1: "portfolio.p2.analysis.description1",
      role1: "portfolio.p2.analysis.role1",

      subject2: "portfolio.p2.analysis.subject2",
      name2: "portfolio.p2.analysis.name2",
      description2: "portfolio.p2.analysis.description2",
      role2: "portfolio.p2.analysis.role2",

      subject3: "portfolio.p2.analysis.subject3",
      name3: "portfolio.p2.analysis.name3",
      description3: "portfolio.p2.analysis.description3",
      role3: "portfolio.p2.analysis.role3",
    }
  },
  {
    slug: "settleu",
    analysis: {
      sectionTitle: "portfolio.p3.analysis.sectionTitle",
      subject1: "portfolio.p3.analysis.subject1",
      name1: "portfolio.p3.analysis.name1",
      description1: "portfolio.p3.analysis.description1",
      role1: "portfolio.p3.analysis.role1",

      subject2: "portfolio.p3.analysis.subject2",
      name2: "portfolio.p3.analysis.name2",
      description2: "portfolio.p3.analysis.description2",
      role2: "portfolio.p3.analysis.role2",

      subject3: "portfolio.p3.analysis.subject3",
      name3: "portfolio.p3.analysis.name3",
      description3: "portfolio.p3.analysis.description3",
      role3: "portfolio.p3.analysis.role3",
    }
  },
  {
    slug: "dr-julia-scheinecker",
    analysis: {
      sectionTitle: "portfolio.p4.analysis.sectionTitle",
      subject1: "portfolio.p4.analysis.subject1",
      name1: "portfolio.p4.analysis.name1",
      description1: "portfolio.p4.analysis.description1",
      role1: "portfolio.p4.analysis.role1",

      subject2: "portfolio.p4.analysis.subject2",
      name2: "portfolio.p4.analysis.name2",
      description2: "portfolio.p4.analysis.description2",
      role2: "portfolio.p4.analysis.role2",

      subject3: "portfolio.p4.analysis.subject3",
      name3: "portfolio.p4.analysis.name3",
      description3: "portfolio.p4.analysis.description3",
      role3: "portfolio.p4.analysis.role3",
    }
  },
  {
    slug: "sigma-clinica-dental",
    analysis: {
      sectionTitle: "portfolio.p5.analysis.sectionTitle",
      subject1: "portfolio.p5.analysis.subject1",
      name1: "portfolio.p5.analysis.name1",
      description1: "portfolio.p5.analysis.description1",
      role1: "portfolio.p5.analysis.role1",

      subject2: "portfolio.p5.analysis.subject2",
      name2: "portfolio.p5.analysis.name2",
      description2: "portfolio.p5.analysis.description2",
      role2: "portfolio.p5.analysis.role2",

      subject3: "portfolio.p5.analysis.subject3",
      name3: "portfolio.p5.analysis.name3",
      description3: "portfolio.p5.analysis.description3",
      role3: "portfolio.p5.analysis.role3",
    }
  },
  {
    slug: "kaufast",
    analysis: {
      sectionTitle: "portfolio.p6.analysis.sectionTitle",
      subject1: "portfolio.p6.analysis.subject1",
      name1: "portfolio.p6.analysis.name1",
      description1: "portfolio.p6.analysis.description1",
      role1: "portfolio.p6.analysis.role1",

      subject2: "portfolio.p6.analysis.subject2",
      name2: "portfolio.p6.analysis.name2",
      description2: "portfolio.p6.analysis.description2",
      role2: "portfolio.p6.analysis.role2",

      subject3: "portfolio.p6.analysis.subject3",
      name3: "portfolio.p6.analysis.name3",
      description3: "portfolio.p6.analysis.description3",
      role3: "portfolio.p6.analysis.role3",
    }
  }
];
